export const projectsList = {
  label: 'Nom des Projets',
  price: 'Prix du projet: 3.400 €',
  execution: 'Exécution du budget: 324.166 €',
};
